import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../global/context/Provider";
import { GlobalStyle } from "../global/styled/GlobalStyle";
import RouterPortal from "./routes/routes";

const PortalContainer = () => {
  const { configState } = useContext(GlobalContext);
  const [appMode, setAppMode] = useState("");

  useEffect(() => {
    if (configState.config.data) {
      setAppMode(configState.config.data.modoEstilo);
    }
  }, [configState.config.data]);

  return (
    <>
      <GlobalStyle mode={appMode} />
      <RouterPortal />
    </>
  );
};

export default PortalContainer;
